// The "design elements" colours (filter, selection, modals, lightbox), read from the CSS vars
// DesignThemeProvider writes so every surface resolves the same palette.
const background = 'var(--ui-background, #ffffff)';
const ink = 'var(--ui-text, #000000)';

export const uiSurface = {
  background,
  ink,
  // Chips and section rows: the surface lifted one step towards the ink.
  raised: `color-mix(in srgb, ${ink} 6%, ${background})`,
  // Hairlines between rows and around the trigger.
  border: `color-mix(in srgb, ${ink} 15%, transparent)`,
  // Secondary labels and placeholders.
  muted: `color-mix(in srgb, ${ink} 60%, transparent)`
} as const;

// Inputs, textareas and dropdowns stay white whatever the design-element colours are.
export const uiField = {
  background: '#ffffff',
  ink: '#000000',
  placeholder: '#8c8c8c',
  border: '#d9d9d9',
  // Hovered / selected dropdown option.
  raised: '#f2f2f2'
} as const;
